import { namespace as createVuexClass } from 'vuex-class';
import { InstanceRelated } from 'ctp-toll-domain';

export const namespace = 'datInstances';
export const store = createVuexClass(namespace);

export const FETCH_DAT_INSTANCES = 'fetchDatInstances';
export const CREATE_DAT_INSTANCE = 'createDatInstance';
export const UPDATE_DAT_INSTANCES_STATE = 'updateDatInstancesState';
export const ARCHIVE_DELETE_DAT_INSTANCE = 'archiveDeleteDatInstance';
export const ARCHIVE_DAT_INSTANCE = 'archiveDatInstance';
export const SET_ERROR = 'setError';
export const SET_NOTIFICATION = 'setNotification';

export interface IFilesState {
  [view: string]: boolean;
}

export interface IInstancesValueState {
  [view: string]: boolean;
}

export interface INotification {
  notificationStatus: string;
  code: number;
  content?: string;
  field?: string;
}

export interface IFilesStatePayload {
  stateKey: string;
  view: string;
  stateValue: boolean;
}

export interface IDatInstancesState {
  [state: string]: IFilesState;
}

export interface IFile {
  creationDate: number;
  activated: boolean;
  eid: number;
  datFile: {
    id: string;
    name: string;
  };
  kind: 'efc' | 'ccc' | 'uni' | 'lac';
  masterId: number;
  name: string;
  validTo?: number;
  deleted: boolean;
}

export interface IInstancesState {
  [state: string]: IInstancesValueState;
}

export interface DatInstancesState {
  datInstancesState: IDatInstancesState;
  instances: Array<IFile>;
  fileByEid: IFile | undefined;
  errorMessage: string;
  notification: INotification | undefined;
}

export interface InstancesState {
  instancesState: IInstancesState;
  instances: Array<InstanceRelated>;
  errorMessage: string;
  notification: INotification | undefined;
}

export enum DatInstanceStateEnum {
  Incative = 'inactive',
  Active = 'active',
  Archived = 'archived'
}

export enum DatInstanceFlagEnum {
  Unused = 'unused',
  Used = 'used'
}
